export const NONE_OPTION = 'NONE_OPTION'
